import { updateUserCompany } from 'api/company';
import { debounceCity, debounceState, debounceViaCep } from 'utils/debounces';

import type { FormType } from '..';

export const companyForm: FormType = {
  updateFn: updateUserCompany,
  cancelText: 'Cancelar',
  submitText: 'Salvar Empresa',
  successText: 'Empresa salva com sucesso!',
  fields: [
    [
      {
        name: 'name',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Nome da empresa',
          label: 'Nome',
        },
      },
    ],
    [
      {
        name: 'corporateName',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Razão social',
          label: 'Razão Social',
        },
      },
    ],
    [
      {
        name: 'documentNumber',
        type: 'text',
        required: true,
        mask: 'maskCnpj',
        props: {
          placeholder: 'CNPJ',
          label: 'CNPJ',
        },
      },
      {
        name: 'email',
        type: 'text',
        required: true,
        props: {
          placeholder: 'nome@email.com',
          label: 'Email',
        },
      },
    ],
    [
      {
        name: 'localPhone',
        type: 'text',
        required: false,
        mask: 'maskLocalPhone',
        props: {
          placeholder: '(00) 9 8765-4321',
          label: 'Telefone',
        },
      },
      {
        name: 'phone',
        type: 'text',
        required: true,
        mask: 'maskPhone',
        props: {
          placeholder: '(00) 9 8765-4321',
          label: 'Celular',
        },
      },
    ],
    [
      {
        name: 'address.postalCode',
        type: 'text',
        required: true,
        onChange: (event, setValue) => {
          const handleAddress = (data) => {
            setValue('address.street', data.logradouro);
            setValue('address.district', data.bairro);
            setValue('address.city', {
              label: data.localidade,
              name: data.localidade,
            });
            setValue('address.state', {
              label: data.uf,
              name: data.uf,
            });
          };
          debounceViaCep(event.target.value, handleAddress);
        },
        props: {
          viewProps: {
            width: '49%',
          },
          placeholder: '000000-000',
          label: 'CEP',
        },
      },
    ],
    [
      {
        name: 'address.street',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Ex: Rua Eduardo Menezes',
          label: 'Endereço',
        },
      },
      {
        name: 'address.number',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Ex: 000 A',
          label: 'Número',
        },
      },
    ],
    [
      {
        name: 'address.complement',
        type: 'text',
        required: false,
        props: {
          placeholder: 'Ex: Bloco 3',
          label: 'Complemento',
        },
      },
      {
        name: 'address.district',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Ex: São Mateus',
          label: 'Bairro',
        },
      },
    ],
    [
      {
        name: 'address.city',
        type: 'select',
        required: true,
        props: {
          placeholder: 'Buscar',
          label: 'Cidade',
          loadOptions: debounceCity,
        },
      }, {
        name: 'address.state',
        type: 'select',
        required: true,
        props: {
          placeholder: 'Buscar',
          label: 'Estado',
          loadOptions: debounceState,
        },
      },
    ],
  ],
};
